import React from "react"
import { useTranslation } from "react-i18next"

import {
  deliveryTypeLabels,
  languageDateFormatMap,
  orderStatusLabels,
  paymentTypesLabel
} from "constant"
import { moment, scale } from "utils"

const PloptfcustomerHeader = (props) => {
  const { templateType, printData, printerWidth } = props

  const {
    date,
    code,
    isCod,
    orderStatus,
    kitchenTitle,
    serviceTypeName,
    paymentType,
    tableNumber,
    deliveryType,
    queueNumber,
    cinemaSolonNumber
  } = printData

  const [t, i18n] = useTranslation()

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  const showTableNumber =
    !!tableNumber &&
    serviceTypeName === "restaurant"

  const dateFormat =
    languageDateFormatMap[i18n.language]

  return (
    <div style={styles["container"]}>
      <div style={styles["headerTable"]}>
        <div style={styles["row"]}>
          <div style={styles["cell1"]}>
            <div style={styles["center"]}>
              {moment(date).format("HH:mm")}
            </div>

            <div style={styles["center"]}>
              {moment(date).format(dateFormat)}
            </div>
          </div>

          <div style={styles["cell2"]}>
            <div style={styles["center"]}>
              {kitchenTitle}
            </div>
          </div>

          <div style={styles["cell1"]}>
            <div style={styles["center"]}>
              {t("فاکتور")}
            </div>
            <div style={{ ...styles["text1"], ...styles["center"] }}>
              {code}
            </div>
          </div>
        </div>

        <div style={styles["row"]}>
          <div style={styles["cell3"]}>
            <div style={styles["center"]}>
              {t("روش پرداخت")}:{" "}
              <span className={styles["bold"]}>
                {isCod ? t("نقدی") : t(paymentTypesLabel[paymentType])
                }
              </span>
            </div>

            <div style={styles["center"]}>
              {t("وضعیت پرداخت")}:{" "}
              <span style={styles["bold"]}>
                {t(orderStatusLabels[orderStatus])}
              </span>
            </div>

            <div style={styles["center"]}>
              {t("نحوه تحویل")}:{" "}
              <span className={styles["bold"]}>
                {t(deliveryTypeLabels[deliveryType])}
                {deliveryType === "cinema" ? ` (${t(cinemaSolonNumber)})` : ""}
              </span>
            </div>

            {
              showTableNumber &&
              <div style={styles["text1"]}>
                {t("میز")}:{" "}
                <span className={styles["bold"]}>
                  {tableNumber}
                </span>
              </div>
            }
          </div>
          <div style={{ ...styles["cell1"], ...styles["borderTop"] }}>
            <div style={styles["center"]}>
              {t("شماره")}
            </div>

            <div style={styles["center"]}>
              {queueNumber}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const stylesThermal = (printerWidth, dir = "rtl") => ({
  container: {
    fontSize: scale("19px", printerWidth),
    paddingTop: scale("10px")
  },

  borderTop: {
    borderTop: `${scale("2px")} solid black`
  },

  headerTable: {
    border: `${scale("2px")} solid`,
  },

  row: {
    display: "flex",
    flexDirection: "row",
  },

  cell1: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },

  cell2: {
    flex: 2,
    borderLeft: `${scale("2px")} solid`,
    borderRight: `${scale("2px")} solid`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },

  cell3: {
    flex: 3,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: `${scale("2px")} solid`,
    borderTop: `${scale("2px")} solid`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  center: {
    textAlign: "center"
  },

  text1: {
    borderTop: `${scale("2px")} solid`,
    width: "100%"
  },

  bold: {
    fontWeight: "bold"
  }
})

const stylesOthers = (dir = "rtl") => ({
  container: {
    marginRight: "8px",
    paddingTop: "4px",
    fontSize: "11px"
  },

  borderTop: {
    borderTop: "2px solid black"
  },

  headerTable: {
    border: "1px solid"
  },

  row: {
    display: "flex",
    flexDirection: "row"
  },

  center: {
    textAlign: "center"
  },

  cell1: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },

  cell2: {
    flex: 2,
    borderLeft: "1px solid",
    borderRight: "1px solid",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },

  cell3: {
    flex: 3,
    [dir === "rtl" ? "borderLeft" : "borderRight"]: "1px solid",
    borderTop: "1px solid",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },

  text1: {
    borderTop: "1px solid",
    width: " 100%"
  },

  bold: {
    fontWeight: "bold"
  }
})

export default PloptfcustomerHeader
